module.exports = __webpack_public_path__ + "static/media/success-illu.ba7e6958.svg";